import { Grid, makeStyles } from '@material-ui/core';
import React, { useMemo, useState } from 'react';

import { Classifier } from '../../../generated/model/classifier';
import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';
import { useOnChange } from '../../../hooks/useOnChange';
import InputDropdown from '../Dropdown';
import { SelectOption } from '../Dropdown/Dropdown';

interface OwnProps {
  defaultState: { version: string };
  defaultValue?: string;
  onChange: (values: { version: string }) => void;
  items: Classifier[];
}

export function InputVersionDropdown({
  onChange,
  defaultState,
  defaultValue = '',
  items,
}: Readonly<OwnProps>) {
  const classes = useStyles();
  const [state, setState] = useState<{ version: string }>(defaultState);

  useDefaultValueWatcher({ defaultValue: defaultState, state, setState });
  useOnChange(onChange, state);
  const options: SelectOption[] = useMemo(() => formatClassifiersToSelectOptions(items), [items]);

  return (
    <Grid item className={classes.dropdown}>
      <InputDropdown
        label=""
        defaultValue={[defaultValue]}
        options={options}
        onChange={handleDropdownChange}
      />
    </Grid>
  );

  function handleDropdownChange(value: string) {
    const newState = {
      ...state,
      version: state.version,
    };
    if (state.version !== value) {
      newState.version = value;
    }
    setState(newState);
  }
}

function formatClassifiersToSelectOptions(classifiers: Classifier[]): SelectOption[] {
  return classifiers.reduce((options: SelectOption[], classifier: Classifier) => {
    if (classifier.id && classifier.name) {
      options.push({
        value: classifier.id,
        label: classifier.name,
      });
    }

    return options;
  }, []);
}

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '10px 0',
  },
  gridItem: {
    width: '50%',
  },
  gridLabel: {
    margin: theme.spacing(0),
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(4),
    textTransform: 'none',
  },
  dropdownRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(4),
  },
  dropdownLabel: {
    marginRight: theme.spacing(2),
  },
  dropdown: {
    width: '90%',
  },
}));
